import React, { Fragment } from 'react';
import NumberFormat from 'react-number-format';
import { bool, number } from 'prop-types';

const FormatNumber = ({
  value,
  isSymbol,
  decimalScale = 2,
  fixedDecimalScale = false
}) => (
  <NumberFormat
    fixedDecimalScale={fixedDecimalScale}
    value={value || 0}
    displayType="text"
    thousandSeparator="."
    decimalSeparator=","
    decimalScale={decimalScale}
    // eslint-disable-next-line no-shadow
    renderText={(parseValue) => {
      let revaluated = 0;
      if (isSymbol) {
        if (parseFloat(value) === 0) {
          revaluated = parseValue;
        } else if (parseFloat(value) > 0) {
          revaluated = `+${parseValue}`;
        } else {
          revaluated = `${parseValue}`;
        }
      } else {
        revaluated = parseValue;
      }
      return <Fragment>{revaluated}</Fragment>;
    }}
  />
);

FormatNumber.propTypes = {
  decimalScale: number,
  fixedDecimalScale: bool,
  isSymbol: bool,
  value: number
};

FormatNumber.defaultProps = {
  decimalScale: 2,
  fixedDecimalScale: false,
  isSymbol: false,
  value: 0
};

export default FormatNumber;
